module.exports = __webpack_public_path__ + "static/media/Medal-2.3593c253.svg";